import React from 'react'

const CalendarSection = () => {
    const calendars = pros.map(pro => <Calendar key = {pro} pro = {pro}/>)
  return (
    <div className = "w-[55%] mx-auto mt-16 mb-5 flex justify-between">
        {calendars}
    </div>
  )
}

export const Calendar = ({pro}:{
    pro:string
}) => {
    return (
        <div className='h-[116px] w-[111px] rounded-xl border-2 border-light-blue relative p-2 pt-7 text-center'>
            <div className = "absolute h-[25px] border border-light-blue top-[-12%] left-[25%]"></div>
            <div className = "absolute h-[25px] border border-light-blue top-[-12%] left-[50%]"></div>
            <div className = "absolute h-[25px] border border-light-blue top-[-12%] left-[75%]"></div>
            <p className = "text-sm text-main-black">{`${pro}`}</p>
        </div>
    )
}

const pros = [
    "Access unlimited job prep. tutorial videos",
    "Get rid of out dated resumes",
    "Take personality and skill based tests",
    "Ace your interviews at one go!"
]

export default CalendarSection